import { Grid } from '@mui/material';
import InfoValueRow from '@shared/components/InfoValueRow';
import HorizontalSeparator from '@shared/pages/Flights/components/HorizontalSeparator';

const WithRecargo = ({ cardData }) => (
  <Grid container direction="column">
    <HorizontalSeparator color="#E5E5E5" />

    <InfoValueRow label="Total" value={cardData.priceTotal} isPrice mt={1} />

    <InfoValueRow label="Recargo" value={cardData.recargo} isPrice />

    <HorizontalSeparator color="#E5E5E5" />

    <InfoValueRow
      label="Total a financiar"
      value={cardData.priceTotal + cardData.recargo}
      isPrice
      boldLeft
      pago
      color="red"
      boldRight
      fontSize={{ xs: '17px', md: '18px', lg: '15px', xl: '18px' }}
    />
  </Grid>
);

export default WithRecargo;
